import { render, staticRenderFns } from "./HMGlobalForm.vue?vue&type=template&id=a3a6b63e&"
import script from "./HMGlobalForm.vue?vue&type=script&lang=ts&"
export * from "./HMGlobalForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports